<template>
	<modal @close="$emit('close')">
		<div
			class="notification-preview"
			slot="content"
		>
			<header class="notification-preview__header">
				<div class="notification-preview__avatar"/>

				<h4 class="notification-preview__title">
					Upmood
				</h4>

				<p class="notification-preview__date">
					{{ dateTime }}
				</p>
			</header>

			<section class="notification-preview__content">
				<h4 class="notification-preview__title">
					{{ notification.title }}
				</h4>

				<p class="notification-preview__detail">
					{{ notification.description || '--' }}
				</p>
			</section>
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/utils/Modal.vue'

export default {
	props: {
		notification: Object
	},

	computed: {
		dateTime () {
			const { time, date } = this.notification
			if (!time && !date) return '--'

			const { filters } = this.$options
			const timeFormatted = filters.dateFormatter(time, 'hh:mm A')
			return `${filters.dateFormatter(date, 'MMM D, YYYY')} ${timeFormatted}`
		}
	},

	components: {
		Modal
	}
}
</script>

<style lang="scss" scoped>
.notification-preview {
	width: 400px;
	min-height: 300px;
	padding: 20px;
	border-radius: 10px;
	background-color: #fff;

	&__header {
		display: flex;
		align-items: center;

	}

	&__avatar {
		width: 2em;
		height: 2em;
		background-color: #ddd;
		border-radius: 50%;
		margin-right: 1em;
	}

	&__title {
		flex: 1 1 auto;
		margin: 1em 0;
	}

	&__date {
		font-size: .8em;
	}

	&__content {
		margin-top: 2em;
	}
}
</style>
